import React from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

export default function LandingPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();

  // If user opens quiz link like /?quiz=XXXX → redirect to /start?quiz=XXXX
  const quizCode = params.get("quiz");
  React.useEffect(() => {
    if (quizCode) {
      navigate(`/start?quiz=${quizCode}`);
    }
  }, [quizCode, navigate]);

  return (
    <div
      style={{
        minHeight: "100vh",
        background:
          "linear-gradient(135deg, #0f172a 0%, #1e3a8a 50%, #0ea5e9 100%)",
      }}
    >
      {/* Top Navbar */}
      <div className="container py-3">
        <div className="d-flex justify-content-between align-items-center">
          <div className="text-white fw-bold fs-4">Online Quiz System</div>

          <div className="d-flex gap-3">
            <Link className="btn btn-outline-light btn-sm" to="/admin-login">
              Admin Login
            </Link>

            <Link
              className="btn btn-outline-warning btn-sm"
              to="/superadmin-login"
            >
              Super Admin Login
            </Link>
          </div>
        </div>
      </div>

      {/* Hero Section */}
      <div
        className="container d-flex align-items-center"
        style={{ minHeight: "85vh" }}
      >
        <div className="row w-100 justify-content-center">
          <div className="col-12 col-md-10 col-lg-7">
            <div className="card shadow-lg border-0 rounded-4">
              <div className="card-body p-5 text-center">
                <h1 className="fw-bold mb-3">Welcome 👋</h1>

                <p className="text-muted fs-5 mb-4">
                  A secure quiz platform where admins create quizzes and share
                  links with students.
                </p>

                <div className="row g-3 mb-4">
                  <div className="col-md-6">
                    <div className="p-3 border rounded-4 h-100">
                      <h5 className="fw-bold mb-2">👨‍🎓 Students</h5>
                      <p className="text-muted mb-0">
                        Students can start quiz only using the quiz link.
                      </p>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="p-3 border rounded-4 h-100">
                      <h5 className="fw-bold mb-2">🧑‍💼 Admins</h5>
                      <p className="text-muted mb-0">
                        Create quiz, add questions, and generate shareable link.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="alert alert-info rounded-4">
                  ⚠️ <b>Students cannot login directly.</b> <br />
                  Please ask your admin for the quiz link.
                </div>

                <div className="d-flex justify-content-center gap-3 mt-3 flex-wrap">
                  <Link
                    to="/admin-login"
                    className="btn btn-primary btn-lg px-4"
                  >
                    Admin Login
                  </Link>

                  <Link
                    to="/admin-register"
                    className="btn btn-outline-secondary btn-lg px-4"
                  >
                    Admin Register
                  </Link>
                </div>

                <small className="text-muted d-block mt-4">
                  Example quiz link: <b>https://telugututorial.in/?quiz=ABCD1234</b>
                </small>
              </div>
            </div>

            <div className="text-center text-white-50 mt-3">
              © {new Date().getFullYear()} Online Quiz System
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
